import { useSelector } from "react-redux";
import styled from "styled-components";
import { useEffect, useState } from "react";

// Components
import CommonButton from "../../../../components/common/CommonButton";
import StartSimulatorModal from "./StartSimulatorModal";
import AnalysisModal from "./AnalysisModal";
import ChartModal from "./ChartModal";
import { Icon } from "@iconify/react";
import Star from "./Star";

const SimulatorCard = (props) => {

    const { task } = props;
    const [isStartModalOpen, setIsStartModalOpen] = useState(false);
    const [isAnalysisModalOpen, setIsAnalysisModalOpen] = useState(false);
    const [isChartModalOpen, setIsChartModalOpen] = useState(false);
    const [simulatorsInProgress, setSimulatorsInProgress] = useState([]);

    const { authToken } = useSelector((state) => state.auth);

    useEffect(() => {
        setSimulatorsInProgress(JSON.parse(localStorage.getItem("simulators_in_progress")) || []);
    }, [isStartModalOpen])

    const handleStartSimulator = () => {
        
        localStorage.setItem("simulators_in_progress", JSON.stringify([...simulatorsInProgress, task.id]));
        setSimulatorsInProgress([...simulatorsInProgress, task.id]);
        window.open(`https://ai-simulator.aden.org/simulation?simulator_id=${task.simulator_id}&session_id=${task.id}&token=${authToken}`, "_blank");
        setIsStartModalOpen(false)
    };

    const handleViewChartFromAnalysis = () => {
        setIsAnalysisModalOpen(false);
        setTimeout(() => setIsChartModalOpen(true), 300);
    };

    const simulationScore = task?.final_analysis?.final_analysis?.simulation_score || 0;

    const timestampRealized = task?.final_analysis?.timestamp ? new Date(task.final_analysis.timestamp).toLocaleString("es-AR", { year: "numeric", month: "2-digit", day: "2-digit" }).split(" ").reverse().join("-") : "-";

    const renderStatus = () => {
        switch (task.status) {
            case "pending":
                return (
                    <>
                        <Icon icon="material-symbols-light:check-circle-outline-rounded" />
                        <span>Disponible</span>
                    </>
                );
            case "incomplete":
                return (
                    <>
                        <Icon icon="material-symbols:error-circle-rounded-outline" />
                        <span>Incompleto</span>
                    </>
                );
            case "complete":
                return (
                    <>
                        <Icon icon="material-symbols:error-circle-rounded-outline" />
                        <span>Realizado</span>
                        <p>{timestampRealized}</p>
                    </>
                );
            default:
                return null;
        }
    }

    return (
        <Wrapper>
            <StateWrapper state={task.status}>
                <label>Estado:</label>
                {renderStatus()}
            </StateWrapper>
            <Container>
                <LeftInfo>
                    <Icon icon="nimbus:rocket" size={24} />
                    <section>
                        <label>SIMULADOR {task?.category?.toUpperCase()}</label>
                        <p>"{task.description}"</p>
                    </section>
                </LeftInfo>
                <RightInfo>
                    {
                        task.status === "pending" &&
                        <>
                            <CommonButton
                                label={simulatorsInProgress.includes(task.id) ? "Simulador en progreso" : "Iniciar simulador"}
                                variant="filled"
                                onClick={() => setIsStartModalOpen(true)}
                                disabled={!task.simulator_id || !task.id || simulatorsInProgress.includes(task.id)}
                            />
                            <StartSimulatorModal
                                isOpen={isStartModalOpen}
                                onClose={() => setIsStartModalOpen(false)}
                                onStart={handleStartSimulator}
                            />
                        </>
                    }
                    {
                        task.status !== "pending" &&
                        <span>
                            <label>Puntaje obtenido</label>
                            <section>
                                {Array.from({ length: 5 }).map((_, i) => {
                                    const fillValue = simulationScore
                                        ? Math.min(1, Math.max(0, simulationScore - i))
                                        : 0
                                    return <Star key={i} fill={fillValue} />;
                                })}
                                <p>
                                    {simulationScore || "-"}
                                </p>
                            </section>
                            <CommonButton
                                label="Ver gráfico"
                                variant="outlined"
                                onClick={() => setIsChartModalOpen(true)}
                                disabled={!task?.final_analysis}
                            />
                            <CommonButton
                                label="Ver análisis"
                                variant="filled"
                                onClick={() => setIsAnalysisModalOpen(true)}
                                disabled={!task?.final_analysis}
                            />
                            <ChartModal
                                isOpen={isChartModalOpen}
                                onClose={() => setIsChartModalOpen(false)}
                                attributes={task?.final_analysis?.final_analysis?.attributes_scores}
                            />
                            <AnalysisModal
                                isOpen={isAnalysisModalOpen}
                                onClose={() => setIsAnalysisModalOpen(false)}
                                onViewChart={handleViewChartFromAnalysis}
                                finalAnalysis={task?.final_analysis?.final_analysis || {}}
                                sessionId={task.id}
                            />
                        </span>
                    }
                </RightInfo>
            </Container>
        </Wrapper>
    )
}

export default SimulatorCard;

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 1rem;
`;

const StateWrapper = styled.div`
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    svg {
        width: 32px;
        height: 32px;
        color: ${({ state }) => state === "pending" ? "#28A986" : state === "incomplete" ? "#b31d15" : "#C29F43"};
    }

    span {
        font-size: 16px;
        font-weight: 600;
        color: ${({ state }) => state === "pending" ? "#28A986" : state === "incomplete" ? "#b31d15" : "#C29F43"};
    }
`;

const Container = styled.div`
    width: 100%;
    height: 100px;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0px 8px 24px -4px #18274B14, 0px 6px 12px -6px #18274B1F;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const LeftInfo = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 2rem;
    padding-left: 3rem;

    svg {
        width: 24px;
        height: 24px;
        color: #b31d15;
    }

    section {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        gap: 0.5rem;

        label {
            color: #b31d15;
        }
    }
`

const RightInfo = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 2rem;

    span {
        display: flex;
        align-items: center;
        gap: 1rem;

        label {
            font-weight: 400;
            font-size: 14px;
            color: #535353;
        }

        section {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #b31d15;
            font-size: 20px;

            p {
                width: 2rem;
                text-align: center;
            }
        }
    }
`
